import { useTranslation } from "react-i18next";

import ToggleButton from "./ToggleButton";

interface GroupToggleButtonsProps {
  displayName?: string;
  displayNamePlural?: string;
  groupedCount?: number;
  ungroupedCount?: number;
  showUngroupedEvents?: boolean;
  setShowUngroupedEvents?: (show: boolean) => void;
  isLoading?: boolean;
}

const GroupToggleButtons = ({
  displayName,
  displayNamePlural,
  groupedCount,
  ungroupedCount,
  showUngroupedEvents,
  setShowUngroupedEvents,
  isLoading,
}: GroupToggleButtonsProps) => {
  const { t } = useTranslation();

  if (!isLoading && !groupedCount && !ungroupedCount) {
    return null;
  }

  return (
    <div className="ml-12 flex gap-x-2">
      {(isLoading || !!groupedCount) && (
        <ToggleButton
          count={groupedCount}
          label={t("pages:dashboard.events_toolbar.grouped_label", {
            dashboardName: displayName ?? displayNamePlural,
            count: groupedCount ?? 0,
          })}
          isActive={!showUngroupedEvents}
          onClick={() => setShowUngroupedEvents?.(false)}
          isLoading={isLoading}
        />
      )}
      {(isLoading || !!ungroupedCount) && (
        <ToggleButton
          count={ungroupedCount}
          label={t("pages:dashboard.events_toolbar.ungrouped_label", {
            dashboardName: displayNamePlural ?? displayName,
          })}
          isActive={!!showUngroupedEvents}
          onClick={() => setShowUngroupedEvents?.(true)}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};

export default GroupToggleButtons;
